import { useStore } from "effector-react";

import SiteStore, {
    SiteStoreState,
    extractContentField,
    updateSiteStore,
    track,
} from "reliance-private-sitebuilder-common/dist/stores/SiteStore";

import { getPhone, classNames, renderHTML } from "reliance-private-sitebuilder-common/dist/util/common-utilities";

import Scroller from "reliance-private-sitebuilder-common/dist/components/Scroller";

export default function Home() {
    const site_store = useStore(SiteStore);
    return (
        <>
            <div className={classNames("rounded-xl")}>
                <div
                    className={classNames(
                        !site_store.site.showFirm ? "hidden" : "",
                        "w-full text-center",
                        "xs:hidden",
                        extractContentField(site_store, "ADVERTISING_HEADER_SMALL").css ?? ""
                    )}
                >
                    <div className={extractContentField(site_store, "PAID_ATTORNEY_ADVERTISING").css ?? ""}>
                        {renderHTML(
                            extractContentField(site_store, "PAID_ATTORNEY_ADVERTISING").value
                                ? extractContentField(site_store, "PAID_ATTORNEY_ADVERTISING").value +
                                      " " +
                                      site_store.site.firm?.name
                                : ""
                        )}
                    </div>
                </div>
                <div
                    className={classNames(
                        "w-full p-2 grid grid-cols-5",
                        "xs:rounded-tl-md xs:rounded-tr-md",
                        "sm:rounded-tl-xl sm:rounded-tr-xl",
                        extractContentField(site_store, "TOP_HEADER").css ?? ""
                    )}
                >
                    <div className={classNames("col-span-3")}>
                        <img
                            className={extractContentField(site_store, "LOGO").css ?? ""}
                            alt="logo"
                            src={`${site_store.strippedUri}/media/${extractContentField(site_store, "LOGO").value}`}
                        />
                    </div>
                    <div className={classNames("col-span-2 grid items-center justify-items-center xs:justify-end")}>
                        <button className={classNames(extractContentField(site_store, "TOP_PHONE").css ?? "")}>
                            <a
                                className={classNames("underline")}
                                href={`tel:${getPhone(site_store)}`}
                                onClick={() =>
                                    track({ action: "click", what: "link", label: "yes", category: "phone" })
                                }
                            >
                                {getPhone(site_store)}
                            </a>
                        </button>
                    </div>
                </div>
                <div
                    className={classNames("w-full bg-color-MAIN_BACKGROUND pt-8 grid justify-items-center", "md:pb-5")}
                >
                    <div className={extractContentField(site_store, "TOP_BANNER_1").css ?? ""}>
                        {renderHTML(extractContentField(site_store, "TOP_BANNER_1").value ?? "")}
                    </div>
                    <div className={extractContentField(site_store, "TOP_BANNER_2").css ?? ""}>
                        {renderHTML(extractContentField(site_store, "TOP_BANNER_2").value ?? "")}
                    </div>
                </div>
                <div className={classNames("w-full justify-center bg-color-CAROUSEL_STATIONARY h-16")}>
                    <Scroller
                        items={(extractContentField(site_store, "CAROUSEL_LIST").value ?? "")
                            .split("\n")
                            .filter((e) => e && e !== "")}
                        n={classNames(
                            "w-full h-16 flex flex-col justify-center items-center",
                            extractContentField(site_store, "CAROUSEL_LIST").css ?? ""
                        )}
                    />
                </div>
                <div className={classNames("w-full bg-color-MAIN_BACKGROUND grid justify-items-center", "md:pt-3")}>
                    <div className={classNames("mx-auto", extractContentField(site_store, "ARROW_TOP_TEXT").css ?? "")}>
                        {renderHTML(extractContentField(site_store, "ARROW_TOP_TEXT").value ?? "")}
                    </div>
                </div>
                <div className={classNames("w-full bg-color-MAIN_BACKGROUND p-4 bg-clip-down")}></div>
                <div className={classNames("w-full grid justify-center pt-6 pb-6")}>
                    <div
                        className={classNames(
                            "mx-auto",
                            extractContentField(site_store, "CTA_BUTTON_TOP_TEXT").css ?? ""
                        )}
                    >
                        {renderHTML(extractContentField(site_store, "CTA_BUTTON_TOP_TEXT").value ?? "")}
                    </div>
                    <button
                        className={classNames(extractContentField(site_store, "CTA_BUTTON").css ?? "")}
                        onClick={() => {
                            track({ action: "click", what: "button", label: "yes", category: "start" });
                            updateSiteStore({ state: SiteStoreState.QUIZ, quizTimestamp: new Date().toISOString() });
                        }}
                    >
                        {renderHTML(extractContentField(site_store, "CTA_BUTTON").value ?? "")}
                    </button>
                </div>
                <div className={classNames("w-full grid justify-center pb-6")}>
                    <div className={classNames("mx-auto", extractContentField(site_store, "PHONE_TEXT").css ?? "")}>
                        {renderHTML(extractContentField(site_store, "PHONE_TEXT").value ?? "")}
                    </div>
                    <div className={classNames("mx-auto", extractContentField(site_store, "PHONE_TEXT").css ?? "")}>
                        <a
                            className={classNames("underline")}
                            href={`tel:${getPhone(site_store)}`}
                            onClick={() => track({ action: "click", what: "link", label: "yes", category: "phone" })}
                        >
                            {getPhone(site_store)}
                        </a>
                    </div>
                </div>
                <div className={classNames("w-full grid justify-center pb-6")}>
                    {renderHTML(extractContentField(site_store, "MAIN_CONTENT").value ?? "")}
                </div>
                <div className={classNames("w-full grid justify-center pt-6 pb-6")}>
                    <div
                        className={classNames(
                            "mx-auto",
                            extractContentField(site_store, "CTA_BUTTON_TOP_TEXT").css ?? ""
                        )}
                    >
                        {renderHTML(extractContentField(site_store, "CTA_BUTTON_TOP_TEXT").value ?? "")}
                    </div>
                    <button
                        className={classNames(extractContentField(site_store, "CTA_BUTTON").css ?? "")}
                        onClick={() => {
                            track({ action: "click", what: "button", label: "yes", category: "start" });
                            updateSiteStore({ state: SiteStoreState.QUIZ, quizTimestamp: new Date().toISOString() });
                        }}
                    >
                        {renderHTML(extractContentField(site_store, "CTA_BUTTON").value ?? "")}
                    </button>
                </div>
                <div className={classNames("w-full grid justify-center pb-6")}>
                    <div className={classNames("mx-auto", extractContentField(site_store, "PHONE_TEXT").css ?? "")}>
                        {renderHTML(extractContentField(site_store, "PHONE_TEXT").value ?? "")}
                    </div>
                    <div className={classNames("mx-auto", extractContentField(site_store, "PHONE_TEXT").css ?? "")}>
                        <a
                            className={classNames("underline")}
                            href={`tel:${getPhone(site_store)}`}
                            onClick={() => track({ action: "click", what: "link", label: "yes", category: "phone" })}
                        >
                            {getPhone(site_store)}
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}
